export const range = (start = 0, end = start + 1, step = 1): number[] => {
    const output = [];

    for (let i = start; i < end; i += step) {
        output.push(i);
    }

    return output;
};

export const generateIdArray = (amount: number): number[] => range(0, amount);

export const shuffleArray = <T>(array: T[]): T[] => {
    const shuffledArray = [...array];

    return shuffledArray
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
};
